import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";


@Injectable()
export class ClinicProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listClinics(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/clinics`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getClinic(program_id: string, clinic_id: string) {
    return this.afs.collection<any>(`program/${program_id}/clinics`).doc(clinic_id);
  }

  getClinicByVector(program_id: string, program_institution_id: string) {
    console.log('Get clinic for: ', program_id, program_institution_id);
    return this.afs.collection<any>(`program/${program_id}/clinics`, ref =>
      ref.where("program_institution_id","==", program_institution_id)
    );
  }

  addClinic(program_id: string, clinic: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    clinic = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...clinic };
    return this.afs.collection<any>(`program/${program_id}/clinics`).doc(doc_id).set(clinic);
  }

  updateClinic(program_id: string, clinic_id, clinic: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    clinic = { updatedAt, updatedBy, ...clinic };
    return this.afs.collection<any>(`program/${program_id}/clinics`).doc(clinic_id).update(clinic);
  }

  deleteClinic(program_id: string, clinic_id: string)  {
    var batch = this.afs.firestore.batch();
    const docRef = this.afs.doc(`program/${program_id}/clinics/${clinic_id}`).ref;
    batch.delete(docRef);
    return batch.commit();
  }
}



// WEBPACK FOOTER //
// ./src/providers/clinic/clinic.ts